"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreamScheme = exports.OutputFnType = void 0;
var OutputFnType;
(function (OutputFnType) {
    OutputFnType[OutputFnType["XSH_RR"] = 0] = "XSH_RR";
    OutputFnType[OutputFnType["XSH_RS"] = 1] = "XSH_RS";
    OutputFnType[OutputFnType["XSL_RR"] = 2] = "XSL_RR";
    // XSL_RR_RR = 3 // currently unstable
    OutputFnType[OutputFnType["RXS_M_XS"] = 4] = "RXS_M_XS";
})(OutputFnType || (exports.OutputFnType = OutputFnType = {}));
// TODO: Implement more stream schemes
var StreamScheme;
(function (StreamScheme) {
    StreamScheme[StreamScheme["SETSEQ"] = 0] = "SETSEQ";
    StreamScheme[StreamScheme["ONESEQ"] = 1] = "ONESEQ";
    // UNIQUE = 2,
    StreamScheme[StreamScheme["MCG"] = 3] = "MCG";
})(StreamScheme || (exports.StreamScheme = StreamScheme = {}));
